// Material UI
import { makeStyles } from '@material-ui/core'
// constant
import Colors from '../../constants/Colors'

export default makeStyles(theme => {
  return {
    Container: {
      display: 'flex',
      justifyContent: 'space-between',
      flexDirection: 'column',
      [theme.breakpoints.up('md')]: {
        flexDirection: 'row',
      },
    },
    whimContent: {
      display: 'flex',
      justifyContent: 'space-between',
      padding: '24px',
      fontSize: '17px',
      fontFamily: 'Poppins',
    },
    title: {
      padding: '24px',
      fontSize: '17px',
      fontFamily: 'Poppins',
      borderBottom: `1px solid ${Colors.BACKGROUND_ALTERNATIVE_COLOR}`,
    },
    deleteWhim: {
      width: '100%',
      [theme.breakpoints.up('md')]: {
        borderTop: `1px solid ${Colors.BACKGROUND_ALTERNATIVE_COLOR}`,
        display: '-webkit-box',
      },
    },
    content: {
      backgroundColor: Colors.WHITE,
      marginBottom: '12px',
      marginTop: '10px',
      margin: 24,
    },
    subTotalContent: {
      display: 'flex',
      justifyContent: 'space-between',
      padding: '24px',
      fontSize: '17px',
      fontFamily: 'Poppins',
      borderTop: `1px solid ${Colors.BACKGROUND_ALTERNATIVE_COLOR}`,
    },
    priceFont: {
      fontFamily: 'Poppins Bold',
    },
  }
})
